import { Routes, Route, NavLink } from 'react-router-dom';
import { useAuthContext } from '../../../context/AuthContext/AuthContext';
import { AuthActionType } from '../../../context/AuthContext/AuthReducer';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import style from './header.module.scss';
import Dropdown from 'react-bootstrap/Dropdown';
import {
  MdOutlineShoppingBag as HeaderCart,
  MdNotificationsActive as HeaderBell,
  MdHome as HeaderShop,
  MdLogout as HeaderLogout,
  MdLockOutline as HeaderLogin,
  MdOutlineAdminPanelSettings as MenuAdmin
} from 'react-icons/md';

import {
  FaUserCog as HeaderUser,
  FaCog as HeaderSettings
} from 'react-icons/fa';

// Import the new Order model
import { Order } from '../../../models/Order/Order';
import { OrderStatus } from '../../../models/Order/contracts';

export default function Header() {
  const { user, dispatch } = useAuthContext();
  const [pendingOrdersCount, setPendingOrdersCount] = useState<number>(0);
  const navigate = useNavigate();

  // Use our new Order model to fetch only pending orders.
  // We set per_page to 1 because we only need the pagination metadata for the total count.
  const { data: pendingOrdersResponse } = useQuery(
    ['pendingOrdersCount'],
    () => Order.getAll({ status: 'pending', per_page: 1 }),
    {
      // Only run the query if the user is logged in.
      enabled: !!user
    }
  );

  useEffect(() => {
    // Set the count from the 'total' property of the pagination object.
    if (pendingOrdersResponse?.pagination?.total) {
      setPendingOrdersCount(pendingOrdersResponse.pagination.total);
    }
  }, [pendingOrdersResponse]);

  return (
    <div className={style.adminHeader}>
      <div></div>
      <div>
        <button className={style.headerButton}>
          <HeaderShop
            onClick={() => {
              navigate('/admin');
            }}
          />
        </button>
        <button
          className={style.headerButton}
          onClick={() => navigate('/admin/orders')}
        >
          <HeaderBell />
          {pendingOrdersCount > 0 && (
            <div className={style.notification}>
              <span>{pendingOrdersCount}</span>
            </div>
          )}
        </button>

        {(!!user && (
          <Dropdown className={style.dropdownButton}>
            <Dropdown.Toggle variant="transparent" id="dropdown-basic">
              <HeaderUser />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <p className={style.dropdownTitle}>{user?.name}</p>
              <p className={style.dropdownEmail}>{user?.email}</p>
              <div
                className={style.dropdownLinks}
                onClick={() => navigate('/admin')}
              >
                <span>
                  <MenuAdmin />
                </span>
                <span>Admin Panel</span>
              </div>
              <div className={style.dropdownLinks} onClick={() => navigate('/admin/configurations')}>
                <span>
                  <HeaderSettings />
                </span>
                <span>Settings</span>
              </div>
              <div
                className={style.dropdownLinks}
                onClick={() => {
                  dispatch({ type: AuthActionType.LOGOUT });
                }}
              >
                <span>
                  <HeaderLogout />
                </span>
                <span>Logout</span>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        )) || (
          <NavLink to="/login" className={style.headerButton}>
            <HeaderLogin />
          </NavLink>
        )}
      </div>
    </div>
  );
}
